<template>
  <div class="page">

    <div v-if="model != null">
      <van-panel class="panel-info">
        <van-cell slot="header" icon="orders-o" :title="$store.state.OrderTypeEnum.getLabel(model.type)+(model.options?model.options.isExcludeOrderedClerk?'(排除单)':'':'')">
            <van-tag  v-if="model.status == 0" type="danger" size="medium">待接单</van-tag>
            <van-tag v-else-if="model.status == 1" color="#ff976a" size="medium">待开始</van-tag>
            <van-tag v-else-if="model.status == 2" type="primary" size="medium">服务中</van-tag>
            <van-tag v-else-if="model.status == 3" type="success" size="medium">已完成</van-tag>
            <van-tag v-else-if="model.status == -1" size="medium">已取消</van-tag>
        </van-cell>
        <!--    用户信息      -->
        <van-cell class="cell-padding" size="large" center
                  :clickable="isAuthority()"
                  :is-link="isAuthority()"
                  :to="isAuthority() ? '/admin/user/detail/'+ model.userId:null">
          <div class="user-item">
            <div class="left align-center">
              <div class="user_head">
                <van-image
                    round
                    width="60px"
                    height="60px"
                    :src="model.headImgUrl">
                </van-image>
                <div class="avatarFrame" v-if="model.levelFrameUrl">
                  <img width="80px" height="80px" :src="model.levelFrameUrl"/>
                </div>
                <van-tag v-if="model.levelName" class="level" type="primary" round size="medium">{{ model.levelName }}</van-tag>
              </div>
              <div class="padding-left-sm">
                <!-- id 已关注 黑名单 -->
                <div class="left-sm-tag">
                  <van-tag plain type="primary">ID：{{ model.userId }}</van-tag>
                  <van-tag v-if="model.subscribe == 1" type="success">已关注</van-tag>
                  <van-tag v-else plain>未关注</van-tag>
                  <van-tag v-if="$hasFeature('user_violation_share') && model.userViolationSignList && model.userViolationSignList.length > 0" plain color="#91d5ff" @click.stop.prevent="showViolation = true" >
                    <a>{{ model.userViolationSignList.length }}条违规</a>
                  </van-tag>
                  <van-tag v-if="model.isBlacklist" type="default" color="black">黑名单</van-tag>
                </div>
                <!-- 用户昵称 1条违规 -->
                <div>
                  <span>{{ model.userName }}</span>
                </div>
                <!-- 推荐人：xxx -->
                <div v-if="model.distributorName" class="recommend">
                  推荐人：{{ model.distributorName }}
                </div>
              </div>
            </div>
            <div class="right">
            </div>
          </div>
        </van-cell>
        <div class="content">
          <div class="row">
            <span class="label">订单号</span>
            <span class="value">{{model.no}}</span>
          </div>
          <div v-if="model.type != 'reward'" class="row">
            <span class="label" >订单内容</span>
            <span class="value">
              {{model.itemCategory != null ? model.itemCategory.name + '-' : ''}}
              {{model.item.names.join('-')}} × {{model.num}}</span>
          </div>
            <div class="row">
                <span class="label">下单时间</span>
                <span class="value">{{formatDate(model.createTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                <span v-if="model.status == 0">已等待 {{formatTimeDiff(model.createTime, new Date(), 0)}}</span>
            </div>
            <div v-if="model.status >= 1" class="row">
                <span class="label">接单时间</span>
                <span class="value">{{formatDate(model.confirmTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                <span v-if="model.status == 1">已等待 {{formatTimeDiff(model.confirmTime, new Date(), 1)}}</span>
            </div>
            <div v-if="model.status >= 2" class="row">
                <span class="label">开始时间</span>
                <span class="value">{{formatDate(model.startTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
                <span v-if="model.status == 2">剩余时长 {{formatTimeDiff(new Date(), model.expectedEndTime, 2)}}</span>
            </div>
            <div v-if="model.status >= 3" class="row">
                <span class="label">结束时间</span>
                <span class="value">{{formatDate(model.endTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
            </div>
            <div v-if="model.status == -1" class="row">
                <span class="label">取消时间</span>
                <span class="value">{{formatDate(model.cancelTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
            </div>
          <div v-if="model.status == 1" class="row">
            <span v-if="model.type == 'assigned' || model.type == 'reward'" class="label">确认时间</span>
            <span v-if="model.type == 'random'" class="label">抢单时间</span>
            <span class="value">{{formatDate(model.confirmTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div v-if="model.type==='reward'&& model.rewardGift" class="row">
            <span class="label">礼物</span>
            <span class="value">{{model.rewardGift.name}} x {{model.num}}</span>
          </div>
          <template v-if="model.type==='reward'&& model.blindBoxGiftList">
            <div class="row" v-for="(item,index) in model.blindBoxGiftList" :key="index">
              <span class="label">奖品</span>
              <span class="value">{{ item.name }} x {{ item.num }}</span>
            </div>
          </template>
          <div v-if="model.status == -1" class="row">
            <span class="label">取消时间</span>
            <span class="value">{{
                formatDate(model.cancelTime, "YYYY-MM-DD HH:mm:ss")
              }}</span>
          </div>
          <div v-if="model.isContinued != null" class="row">
            <span class="label">是否续单</span>
            <span class="value">
              <van-icon v-if="model.isContinued" name="success" tag="span" color="green" style="height: 20px;line-height: 20px;" />
              <van-icon v-if="!model.isContinued" name="cross" tag="span" color="red" style="height: 20px;line-height: 20px;" />
            </span>
          </div>
          <div class="row">
            <span class="label">店员名称</span><span class="value">{{model.clerkName}}</span>
          </div>
          <div class="row">
            <span class="label">订单金额</span><span class="value">￥{{formatPrice(model.totalAmount)}}</span>
          </div>
          <div v-if="model.userCoupon" class="row">
            <span class="label">优惠金额</span>
            <span class="value">￥{{ formatPrice(model.userCoupon.amount) }}</span>
          </div>
          <div class="row">
            <span class="label">实付金额</span><span class="value">￥{{ formatPrice(model.payAmount) }}</span>
          </div>
          <div class="row" v-show="model.refundFeeSum">
            <span class="label">退款金额</span>
            <div class="value ">
              <div class="flex align-center">
                <span>￥{{ formatPrice(model.refundFeeSum) }}</span>
                <van-button  color="var(--primary-color)" style="height: 24px;line-height: 24px;margin-left: 10px"
                             @click="$router.push(`/order/refund-detail/${model.id}`)">退款记录
                </van-button>
              </div>
            </div>
          </div>
          <template v-if="model.type==='assigned' && model.options">
            <div class="row" v-if="model.options.clerkAddress">
              <span class="label">店员地址</span>
              <span class="value">{{ model.options.clerkAddress.address + model.options.clerkAddress.detailAddress }}</span>
            </div>
            <div class="row" v-if="model.options.userAddress">
              <span class="label">用户地址</span>
              <span class="value">{{ model.options.userAddress.address + model.options.userAddress.detailAddress }}</span>
            </div>
            <div class="row" v-if="model.options.distance">
              <span class="label">距离</span>
              <span class="value">{{ model.options.distance }}km</span>
            </div>
            <div class="row" v-if="model.options.distanceFee">
              <span class="label">出行费</span>
              <span class="value">{{ formatPrice(model.options.distanceFee) }}</span>
            </div>
          </template>
          <div v-if="model.type == 'random' && model.options != null" class="row">
            <span class="label">买家要求</span>
            <span class="value">
              <van-tag v-if="model.options.clerkSex != null && model.options.clerkSex != 0" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">{{$store.state.ClerkSexEnum.getLabel(model.options.clerkSex)}}</van-tag>
              <van-tag v-if="model.options.clerkSex === 0" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">不分男女</van-tag>
              <van-tag v-if="model.options.clerkGrade != null" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">{{$store.state.ClerkGradeMap[model.options.clerkGrade]}}</van-tag>
              <van-tag v-for="(item, index) in model.options.clerkTags" :key="index" plain type="danger" color="#f2826a" size="medium" style="margin-right: 3px;margin-bottom: 5px;">{{item}}</van-tag>
            </span>
          </div>
          <div class="row" v-if="$store.state.shop.id === 47 || $store.state.shop.id === 106">
            <span class="label">服务需求</span><span class="value">{{model.userServiceMemo}}</span>
          </div>
          <div class="row">
            <span class="label">买家备注</span><span class="value">{{model.userMemo}}</span>
          </div>
          <div class="row">
            <span class="label">买家微信</span><span class="value">{{model.userWechatId}}</span>
          </div>
          <div v-if="model.status == -1 && model.refundList" style="display: flex">
            <div style="min-width: 80px;color: #888">退款信息</div>
            <div>
              <div v-for="(item,index) in model.refundList">
                <span v-if="item.operatorRole === 'super_admin'">退款人：超级管理员</span>
                <span v-if="item.operatorRole === 'admin'">退款人：管理员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'leader'">退款人：组长-{{ item.operatorName }}</span>
                <span v-if="item.operatorRole === 'kf'">退款人：客服-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'clerk'">退款人：店员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'user'">退款人：用户</span>
                <span v-if="item.operatorRole === 'system'">退款人：系统</span>
                <span v-if="item.refundDesc" style="padding-left: 10px">原因：{{item.refundDesc}}</span>
              </div>
            </div>
          </div>
          <div v-if="model.refundPhotoUrls && model.refundPhotoUrls.length > 0" class="row">
            <span class="label">取消原因截图</span>
            <div class="screenshot">
              <div v-for="(item,index) in model.refundPhotoUrls" :key="index" class="imgStyle"
                   @click="refundImgClick(index)">
                <img :src="item" class="screenshotImg">
              </div>
            </div>
          </div>
        </div>

        <!-- 退款 -->
        <van-button v-if="$AdminPermission.refundableOrderStatus.includes(model.status) && model.status!==-1" size="large"
                    type="danger" @click="refund()">退款
        </van-button>

      </van-panel>
      <div class="commentBox" v-if="model.photoUrls">
        <div class="row">
          <span class="label">反馈留言</span><span class="value">{{model.content == '' ? '-' : model.content}}</span>
        </div>
        <div class="row">
          <span class="label">反馈截图</span>
          <div class="screenshot">
            <div class="imgStyle" v-for="(item,index) in model.photoUrls" :key="index" @click="imgClick(index)">
              <img :src="item" class="screenshotImg">
            </div>
          </div>
        </div>
      </div>


      <van-dialog v-model="refundShow" :before-close="refundConfirm" show-cancel-button title="退款信息">
        <div>
          <van-field
              v-model="refundFee"
              :disabled="canRefundFee==0"
              label="退款金额"
              placeholder="请输入退款金额"
              required
              type="number"
          />
          <div class="padding-sm" style="float: right;font-size: 10px;padding-top: 0">
            <template v-if="canRefundFee > 0">
              <span style="color: #00BFFF;margin-right: 3px;" @click="canRefund()">全额退款</span>
              <span v-if="msg != null" style="color: red;">{{ msg }}</span>
              <div style="float: right">
                <span>已退 <strong>{{ sumRefundFee }}</strong> 元，</span>
                <span>最多可退 <span style="color: red; font-size: 10px;">{{ canRefundFee }}</span> 元</span>
              </div>
            </template>
            <template v-else-if="canRefundFee == 0">
              <span>订单实付金额为0，请填写退款原因</span>
            </template>
          </div>
        </div>
        <van-field
            v-model="refundReason"
            autosize
            label="退款原因"
            maxlength="100"
            placeholder="请输入退款原因"
            required
            rows="2"
            show-word-limit
            type="textarea"
        />

        <van-cell v-if="refundMethod === 'choose'"  :required="true"  title-class="van-cell__title van-field__label">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <span class="">返还方式</span>
          </template>
          <template #default>
            <van-radio-group v-model="refundPath">
              <van-radio name="original" :disabled="payMode==='balance' || refundMethod!=='choose'">原路返还（{{$store.state.OrderPayModeEnum.valueOf(payMode).label}}）</van-radio>
              <van-radio name="balance" :disabled="payMode==='balance' || refundMethod!=='choose'" style="margin-top: 10px">返还到余额</van-radio>
            </van-radio-group>
          </template>
        </van-cell>

      </van-dialog>
      <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList" :showRole="'kf'"
                       @changeShowViolation="changeShowViolation"></ViolationSelect>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Panel, Cell, CellGroup, Button, Tag, Icon, Toast, Dialog, Field, ImagePreview, Uploader,Image,RadioGroup, Radio } from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  import { getOrder, } from '@/api/admin/order'
  import {getRefundOrder, refund} from "@/api/admin/order";
  import ViolationSelect from '@/components/common/violation-select'

  Vue.use(Panel)
      .use(Cell)
      .use(CellGroup)
      .use(Button)
      .use(Tag)
      .use(Icon)
      .use(Toast)
      .use(Dialog)
      .use(Field)
      .use(Uploader)
      .use(Image)
      .use(Radio)
      .use(RadioGroup)

  export default {
    name: 'admin-order-detail',
    components:{
      ViolationSelect
    },
    data () {
      return {
        showViolation:false,
        model: null,
        refundFee: null,
        refundReason: null,
        refundShow: false,
        refundPath: null,
        refundMethod: null,
        payMode: null,
        payAmount: null,
        sumRefundFee: null,
        canRefundFee: null,
        msg: null,
      }
    },
    methods: {
      //判断权限
      isAuthority(){
        return this.$hasRole('super_admin') || this.$AdminAccess.includes('user-manage')
      },
      changeShowViolation(val){
        this.showViolation = val
      },
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      // 格式化时间差
      formatTimeDiff(start, end,status) {
        start = moment(start)
        end = moment(end)
        const diffSeconds = end.diff(start, 'seconds')
        if (status === 2 && diffSeconds < 1) {
          return '即将完成'
        }
        if (diffSeconds < 60) {
          return `${diffSeconds}秒`
        }
        const diffMinutes = end.diff(start, 'minutes')
        if (diffMinutes < 60) {
          return `${diffMinutes}分钟`
        }
        const diffHours = end.diff(start, 'hours')
        if (diffHours < 24) {
          return `${diffHours}小时`
        }
        const diffDays = end.diff(start, 'days')
        return `${diffDays}天`
      },
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getOrder(this.$route.params.id).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model = data.order;
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
      refundImgClick(i){
        ImagePreview({
          images: this.model.refundPhotoUrls,
          startPosition: i,
        })
      },
      imgClick(i) {
        ImagePreview({
          images: this.model.photoUrls,
          startPosition: i,
        })
      },
      refund() {
        /*获取到退款订单的详情*/
        getRefundOrder(this.model.id).then((res) => {
          this.msg = null
          this.canRefundFee = null
          this.payAmount = null
          const data = res.data
          if (data.code == 0) {
            this.payAmount = Decimal.div(data.data.payAmount, 100).toNumber().toFixed(2)
            this.sumRefundFee = Decimal.div(data.data.sumRefundFee, 100).toNumber().toFixed(2)
            this.canRefundFee = Decimal.sub(this.payAmount, this.sumRefundFee).toNumber().toFixed(2)
            this.payMode = data.data.payMode
            this.refundMethod = data.data.refundMethod
            if(this.payMode === 'balance'){
              this.refundPath = 'balance'
            }else if(this.refundMethod === 'choose'){
              this.refundPath = 'original'
            }else{
              this.refundPath = this.refundMethod
            }
            if (this.canRefundFee == 0) {
              this.refundFee = 0;
            }
            this.refundShow = true
          } else {
            Toast.fail(data.msg)
            this.msg = data.msg
          }
        })
      },
      refundConfirm(action, done) {
        if (action == 'confirm') {
          if (this.refundReason == null || this.refundReason == '') {
            Toast.fail("请输入退款原因")
            done(false)
            return
          }
          if (this.refundFee < 0) {
            Toast.fail("退款金额不能小于0")
            done(false)
            return
          }
          if (Number(this.refundFee) > Number(this.canRefundFee)) {
            Toast.fail("退款金额最多" + this.canRefundFee)
            done(false)
            return
          }
          // 弹出框
          Dialog.confirm({
            title: '确认要申请退款吗？',
          }).then(() => {
            Toast.clear(true)
            Toast.loading()
            // 退款
            refund(
                this.model.id,
                Decimal.mul(this.refundFee, 100).toNumber(),
                this.refundReason,
                this.refundPath).then((res) => {
              Toast.clear()
              const data = res.data
              if (data.code == 0) {
                this.loadData()
                Toast.success('申请退款成功')
                done()
              } else {
                Toast.fail(data.msg)
                done()
              }
            })
            // 关闭上拉菜单
            this.refundShow = false
          }).catch(() => {
            done()
            return
          })
        } else {
          done()
          return
        }
      },
    },
    mounted() {
      this.loadData()
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>

  .page {
    padding-bottom: 100px;

    .panel-info {
      margin-top: 10px;
      .cell-padding{
        padding: 5px 15px 10px;

        .user-item {
          display: flex;
          align-items: center;
          .userMemo {
            color: #999;
          }
          .left {
            flex: 1;
            display: flex;
            .service-info {
              color: #333;
            }
            .created {
              color: #555;
              margin-bottom: 5px;
            }
            .user_head {
              position: relative;
              padding: 10px;
              .avatarFrame {
                position: absolute;
                top: 0;
                left: 0;
              }
              .level {
                position: absolute;
                left: 50%;
                height: 10px;
                font-size: 10px;
                white-space: nowrap;
                bottom: 0px;
                transform: translateX(-50%);
              }
            }
            .padding-left-sm div span{
              margin-right: 4px;
            }
            .recommend{
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              color: #999999;
            }
          }
          .right {
            text-align: right;
            min-width: 30px;
            .total-amount {
              color: #333;
            }
          }
        }
      }
      .content {
        font-size: 14px;
        padding: 0 15px 10px;
      }
    }
    .row {
      display: flex;
      color: #333;
      margin: 10px 0;
      align-items: center;
    }
      .label {
        width: 80px;
        color: #888;
      }

      .value {
        flex: 1;
      }
    .commentBox{
      width: 100%;
      background: #fff;
      padding: 15px;
      margin-top: 20px;
      box-sizing: border-box;
    }
    .imgStyle{
      margin-left: 10px;
      flex: 0 0 15%;
      height: 0;
      padding-bottom: 15%;
      overflow: hidden;
      position: relative;
    }
    .screenshot{
      width: 100%;
      display: flex;
      align-content: flex-start;
      flex-flow: row wrap;
    }
    .screenshotImg{
      width: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }


</style>
